<template>
  <!-- 解绑用户 -->
  <div>
    <el-dialog
      :title="this.$t('button.unbindUser')"
      :visible.sync="unboundVisible"
      width="650px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="dialog-content">
        <div class="tips">{{ $t("pages.equipment.text188") }}</div>
        <el-form
          ref="form"
          :model="params"
          label-width="auto"
          class="demo-ruleForm"
          :rules="rules"
        >
          <el-form-item
            :label="$t('pages.user.text13')"
            v-if="currentEquipment.appAccount"
          >
            <span>{{
              currentEquipment.appAccount ? currentEquipment.appAccount : ""
            }}</span>
          </el-form-item>
          <el-form-item
            :label="$t('pages.equipment.text44')"
            prop="unbindReason"
          >
            <el-input
              type="textarea"
              v-model="params.unbindReason"
              :rows="4"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
        <el-button type="primary" @click="submit">{{
          $t("button.determine")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      params: {
        appCode: "", //app识别码
        bikeCode: "", //车辆编码
        unbindReason: "", //解绑理由
      },
      rules: {
        unbindReason: [
          {
            required: true,
            message: this.$t("pages.equipment.text189"),
            trigger: "blur",
          },
          {
            max: 50,
            message: this.$t("pages.equipment.text173"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    unboundVisible(newValue) {
      if (newValue) {
        this.params.bikeCode = this.currentEquipment.bikeCode;
        console.log(this.currentEquipment);
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: ["unboundVisible", "currentEquipment"],
  methods: {
    //取消
    handleClose() {
      this.params = {
        appCode: "", //app识别码
        bikeCode: "", //车辆编码
        unbindReason: "", //解绑理由
      };
      this.$emit("closeUnbound");
    },
    //确定
    submit() {
      this.params.appCode = this.platformData.appCode;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.request.unbindUserAndBike(this.params).then(() => {
            this.$message.success(this.$t("pages.equipment.text190"));
            this.$emit("equipmentList");
            this.handleClose();
          });
        }
      });
    },
  },
};
</script>


<style scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
}
.tips {
  margin-left: 48px;
  color: #ec808d;
}
</style>